import React from 'react';
import { Table, Icon, Dropdown, Tooltip, StopPropagation, TableCellDropdown, InfoText } from '@weezevent/nacre';
import { useHistory } from 'react-router-dom';
import Style from './widgetRow.module.css';
import { Trans, useTranslation } from 'react-i18next';
import MylanguageSelector from './languageSelector';
import DeleteModal from './widgetDeleteModal';
import ModalIntegrationCode from './modal_integration_code/modalIntegrationCode';
import EventListModal from './eventListModal';

const TooltipIcon = ({ title, iconName, onClick }) => {
    return (
        <Tooltip triggerOnHover title={title} margin={false}>
            <Icon name={iconName} onClick={onClick} />
        </Tooltip>
    );
};

const widgetRow = ({ widget, organizationId, selectAll, triggerRefetch, context }) => {
    const { t } = useTranslation();
    const [show, display] = React.useState(false);
    const [showLanguage, displayLanguage] = React.useState(false);
    const [code, displayCode] = React.useState(false);
    const [showList, setDisplayList] = React.useState(false);
    let newDate = new Date(widget.created);
    let date = [String(newDate.getDate()).padStart(2, '0'), String(newDate.getMonth() + 1).padStart(2, '0'), newDate.getFullYear()].join('/');
    let history = useHistory();
    const [selected, setSelected] = React.useState(false);

    const displayEvents = React.useMemo(() => {
        if (widget.all_events) return <InfoText subtitle={t('ticket.widget.display_events.multi_events')}>{t('ticket.widget.display_events.all')}</InfoText>;
        if (widget.events && widget.events.length > 1 && !widget.event)
            return <InfoText subtitle={t('ticket.widget.display_events.multi_events')}>{t('ticket.widget.display_events.events', { number: widget.events.length })}</InfoText>;
        if (widget.events && widget.events.length === 1 && !widget.event) return <InfoText subtitle={`E${widget.events[0].id}`}>{widget.events[0].name}</InfoText>;
        if (widget.event) return <InfoText subtitle={`E${widget.event.id}`}>{widget.event.name}</InfoText>;
        return <InfoText>{t('ticket.widget.display_events.no_events')}</InfoText>;
    }, [widget, t]);

    const onRowClick = React.useCallback(() => {
        if (context === 'online_ticketing') return history.push(`/ticket/O${organizationId}/online_ticketing/${widget.id}/settings`);
        if (context === 'personal_space') return history.push(`/ticket/O${organizationId}/personal_spaces/${widget.id}/settings`);
        if (widget.widget_key) return history.push(`/ticket/O${organizationId}/widgets/${widget.id}`);
        return history.push(`/ticket/O${organizationId}/widgets/filtered/${widget.id}`);
    }, [organizationId, widget, history, context]);

    const onEyesClick = React.useCallback(() => {
        if (widget.widget_key) return window.open(`${window.weezConfig.api.widgetUrl}/ticket/${widget.widget_key}`, '_blank');
        return window.open(`${window.weezConfig.api.widgetUrl}/ticket/${widget.widget_event_key}`, '_blank');
    }, [widget]);

    React.useEffect(() => {
        setSelected(selectAll);
    }, [selectAll]);
    return (
        <Table.Tr active={selected} onSelected={() => setSelected(!selected)} onClick={onRowClick}>
            <Table.Td>{widget.name}</Table.Td>
            <Table.Td>{date}</Table.Td>
            {/* <Table.Td>Module filtré ou non</Table.Td> */} {/* TODO: uncomment when module type will be functional */}
            <Table.Td>{displayEvents}</Table.Td>
            <Table.Td className={`${Style['icon_container']} ${Style['width-small']}`}>
                <div onClick={event => event.stopPropagation()}>
                    <ModalIntegrationCode widget={widget} code={code} displayCode={displayCode} />
                </div>
                <StopPropagation>
                    <MylanguageSelector widget={widget} showLanguage={showLanguage} displayLanguage={displayLanguage} organizationId={organizationId} />
                    <DeleteModal widget={widget} show={show} display={display} organizationId={organizationId} triggerRefetch={triggerRefetch} />
                    <EventListModal widget={widget} showList={showList} setDisplayList={setDisplayList} context={context} />
                    <TooltipIcon title={t('ticket.widgets.tooltips.list')} iconName="list" onClick={() => setDisplayList(true)} />
                    <TooltipIcon title={t('ticket.widgets.tooltips.preview')} iconName="eye" onClick={onEyesClick} />
                    <TooltipIcon title={t('ticket.widgets.tooltips.code')} iconName="edit-bloc" onClick={() => displayCode(true)} />
                </StopPropagation>
                <TableCellDropdown size={'medium'} className={Style['dropdown_actions']}>
                    <Dropdown.Item onClick={onRowClick}>{t('ticket.common.action.edit')}</Dropdown.Item>
                    <Dropdown.Line />
                    <Dropdown.Item key={3} onClick={() => display(true)} deleteItem>
                        <Trans i18nKey="ticket.common.action.delete">{t('ticket.common.action.delete')}</Trans>
                    </Dropdown.Item>
                </TableCellDropdown>
            </Table.Td>
        </Table.Tr>
    );
};

export default widgetRow;
